"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdmin = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/admin.scss");
var ai_hub_route_utils_1 = require("../shared/utils/ai-hub-route-utils");
var StrategyBuilder_1 = require("../StrategyBuilder/StrategyBuilder");
var Settings_1 = require("../Settings/Settings");
var Platform_1 = require("../Platform/Platform");
var Metrics_1 = require("../Metrics/Metrics");
var Security_1 = require("../Security/Security");
var Extraction_1 = require("../Extraction/Extraction");
/**
 * WsAiHubAdmin - Admin section for AI Hub with sub-tabs for managing
 * Strategy, Platform, Elements (covering metrics, personas, pains,
 * benefits, risks, technologies, data sources, integrations, budget
 * and roadmap items), Security, and AI Hub Settings.
 *
 * @param {WsAiHubAdminProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubAdmin = function (props) {
    var _a, _b, _c, _d, _e;
    var email = ((_a = props.currentUser) === null || _a === void 0 ? void 0 : _a.email) || '';
    var urlSubTab = ai_hub_route_utils_1.getAiHubAdminSubTab(((_b = props.location) === null || _b === void 0 ? void 0 : _b.pathname) || '', ((_c = props.location) === null || _c === void 0 ? void 0 : _c.search) || '');
    var _f = react_1.useState(urlSubTab), subTab = _f[0], setSubTab = _f[1];
    // Update subTab state when URL changes
    react_1.useEffect(function () {
        if (props.location) {
            setSubTab(ai_hub_route_utils_1.getAiHubAdminSubTab(props.location.pathname, props.location.search));
        }
    }, [(_d = props.location) === null || _d === void 0 ? void 0 : _d.pathname, (_e = props.location) === null || _e === void 0 ? void 0 : _e.search]);
    // Function to update URL with the canonical admin path
    var updateSubTabInUrl = function (newSubTab) {
        if (props.history && props.location) {
            props.history.push(ai_hub_route_utils_1.buildAiHubAdminSubTabPath(props.location.pathname, props.location.search, newSubTab));
        }
        setSubTab(newSubTab);
    };
    var renderSubTabContent = function () {
        switch (subTab) {
            case 'strategy-builder':
                return react_1.default.createElement(StrategyBuilder_1.WsAiHubAdminStrategyBuilder, { currentUser: { email: email } });
            case 'platform':
                return react_1.default.createElement(Platform_1.WsAiHubAdminPlatform, null);
            case 'metrics':
                return react_1.default.createElement(Metrics_1.WsAiHubAdminMetrics, null);
            case 'security':
                return react_1.default.createElement(Security_1.WsAiHubAdminSecurity, null);
            case 'settings':
                return react_1.default.createElement(Settings_1.WsAiHubAdminSettings, null);
            case 'extraction':
                return react_1.default.createElement(Extraction_1.WsAiHubAdminExtraction, null);
            default:
                return react_1.default.createElement(StrategyBuilder_1.WsAiHubAdminStrategyBuilder, { currentUser: { email: email } });
        }
    };
    var adminTabs = [
        {
            key: 'strategy-builder',
            label: 'Strategy Builder',
            iconName: 'Lightbulb',
            status: 'ready',
        },
        {
            key: 'platform',
            label: 'Platform',
            iconName: 'Server',
            status: 'placeholder',
        },
        {
            key: 'metrics',
            label: 'Elements',
            iconName: 'BulletedList',
            status: 'ready',
        },
        {
            key: 'security',
            label: 'Security',
            iconName: 'Shield',
            status: 'placeholder',
        },
        {
            key: 'settings',
            label: 'Data Sources',
            iconName: 'Database',
            status: 'ready',
        },
        {
            key: 'extraction',
            label: 'Extraction',
            iconName: 'AnalyticsReport',
            status: 'ready',
        },
    ];
    var statusBadge = {
        placeholder: {
            label: 'Planned',
            tooltip: 'Planned section — no UI or backend implementation yet.',
            className: 'ws-ai-hub-admin-tab-badge--placeholder',
        },
        'ui-only': {
            label: 'UI only',
            tooltip: 'Interface available, but backend logic is not yet wired up — data shown may be mocked.',
            className: 'ws-ai-hub-admin-tab-badge--ui-only',
        },
        ready: {
            label: 'Ready',
            tooltip: 'Ready for integration — UI and backend wiring are in place.',
            className: 'ws-ai-hub-admin-tab-badge--ready',
        },
    };
    return (react_1.default.createElement("div", { className: "ws-ai-hub-admin" },
        react_1.default.createElement("div", { className: "ws-ai-hub-admin-tabs" },
            react_1.default.createElement("div", { className: "tabs is-boxed" },
                react_1.default.createElement("ul", null, adminTabs.map(function (tab) {
                    var badge = tab.status ? statusBadge[tab.status] : undefined;
                    return (react_1.default.createElement("li", { key: tab.key, className: subTab === tab.key ? 'is-active' : '' },
                        react_1.default.createElement("a", { href: "#!", onClick: function (e) {
                                e.preventDefault();
                                updateSubTabInUrl(tab.key);
                            } },
                            react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: tab.iconName, className: "ws-ai-hub-admin-tab-icon" }),
                            react_1.default.createElement("span", null, tab.label),
                            badge && (react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: badge.tooltip },
                                react_1.default.createElement("span", { className: "ws-ai-hub-admin-tab-badge " + badge.className }, badge.label))))));
                })))),
        react_1.default.createElement("div", { className: "ws-ai-hub-admin-content" }, renderSubTabContent())));
};
exports.WsAiHubAdmin = WsAiHubAdmin;
